<template>
  <div class="arrange">
    <div class="title"><img src="../../assets/arrange.png" /></div>
    <div class="lx">连续举办</div>
    <div class="timeline">
      <div class="left">
        <div class="timetitle firsttitle">2019.12 开始报名</div>
        <div class="ss">随时可报名，</div>
        <div class="ss">成绩计入蓝色档案。</div>
        <div class="timetitle endline2020">2020.12.31</div>
        <div class="timetitle end2021">2021.1.1</div>
        <div class="second">第二届</div>
      </div><div class="right">
          <div class="timetitle firsttitle">2020.1.1</div>
          <p class="first">第一届</p>
        <div class="jb"><img src="../../assets/jb.png"/>
          <div class="timetitle">颁奖典礼</div>
        </div>
        <div class="timetitle endline2022"></div>
        <div class="three">第三届</div>
      </div>
    </div>
    <singup></singup>
  </div>
</template>
<script>
  import singup from "../common/singup.vue"
export default {
  components:{
    singup
  }
}
</script>
<style scoped>
.signarrow {
  position: absolute;
  width: 100%;
  bottom: 18vw;
}
.signup {
  text-align: center;
  /*margin-bottom: 33px;*/
}
.signup img {
  width: 77vw;
}
.arrange {
  font-family: "微软雅黑";
  height: 100%;
  background: url("../../assets/commonbg.png") no-repeat center;
  background-size: cover;
  position: relative;
}

.title {
  text-align: center;
  padding-top: 10vh;
}

.title img {
  width: 43%;
}

.lx {
  text-align: center;
  font-size: 4vw;
  font-weight: bold;
  color: #86d4f8;
}
.ss {
  /* text-align: right; */
  font-size: 2.5vw;
  font-weight: bold;
  color: #8289d1;
}

.timeline {
  margin-top: 2vw;
  background: url("../../assets/timeline.png") no-repeat center;
  background-size: contain;
  height: 109vw;
}

.timetitle {
  font-size: 4.5vw;
  height: 7vw;
  line-height: 7vw;
  color: #fff;
}

.left {
  position: relative;
  display: inline-block;
  text-align: right;
  width: 50%;
  padding-right: 5vw;
  margin-top: -0.5vw;
  box-sizing: border-box;
  vertical-align: top;
}

.right {
  padding-top: 14vw;
  vertical-align: top;
  position: relative;
  padding-left: 5vw;
  box-sizing: border-box;
  width: 50%;
  display: inline-block;
  text-align: left;
}

.left p {
  font-size: 2.5vw;
}

.title2020 {
  color: #b9b6e3;
  font-weight: bold;
  padding-right: 2.5vw;
}
.title2022 {
  color: #b9b6e3;
  font-weight: bold;
  padding-right: 2vw;
  padding-top: 71vw;
}

.first {
  color: #357592;
  margin-top: 2vw;
  font-size: 3vw;
  position: absolute;
  left: 1vw;
}

.timetitle2021 {
  color: #b9b6e3;
  position: absolute;
  right: 4vw;
  top: 69vw;
}
/* 
  .first {
    color: #86d4f8;
    text-indent: -4vw;
    font-size: 3vw;
    margin-top: 4vw;
    position: absolute;
    top: 26.5vw;
  } */

.second {
  padding-top: 30vw;
  color: #357592;
  font-size: 3vw;
  position: absolute;
  right: 1vw;
}
.three {
  padding-top: 32vw;
  color: #86D4F8;
  font-size: 4.5vw;
  position: absolute;
  left: 2vw;
  font-weight: bold;
  font-style:italic
}
.bj {
  width: 28vw;
  text-align: center;
}
.bj img {
  width: 4.5vw;
}
.firsttitle {
  /* font-weight: bold; */
}

.endline2022 {
  /* padding-top: 45vw; */
  /* font-weight: bold;
  font-size: 5.5vw;
  font-style:italic; */
  background: url("../../assets/2022.png") no-repeat left;
  background-size: 24vw;
  width: 24vw;
  position: absolute;
  top: 72vw;
}
.jb {
  width: 32vw;
  padding-top: 8.5vw;
  /* font-weight: bold; */
}

.jb img {
  vertical-align: top;
  width: 13vw;
  padding-left: 3vw;
}

.jb .timetitle {
  font-size: 4.5vw;
}

.endline2020 {
  padding-top: 13vw;
  /* position: absolute;
  right: 6vw;
  top: 15.5vw; */
  font-size: 4.5vw;
  /* font-weight: bold; */
}
.end2021 {
  padding-top: 43vw;
  position: absolute;
  right: 6vw;
  top: 15.5vw;
  font-size: 4.5vw;
  /* font-weight: bold; */
}
</style>



// WEBPACK FOOTER //
// src/components/page/arrange.vue